var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _polygon2, _polygon3, _polygon4, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRototiltLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.08 84.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dc0d15;}.cls-2{fill:#1d252c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.3,378c3.3-8.9-19.5-15.3-40.2-17.8a181.07,181.07,0,0,0-30.1-.7,62.17,62.17,0,0,0-3.8,30.4,61.14,61.14,0,0,0,26.4,43l-.7-31.2c1.3-16.8,44-11.1,48.4-23.7",
    transform: "translate(-327.72 -359.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.2,389.2c-8.8,6.9-36.5,5.8-36.9,12.5v.2h0a1.27,1.27,0,0,0,.1.6c0,.1.1.2.1.3l.8,1.5.3.5c5.5,7,14.8,11,24.9,13.2l12.1-30.2a18.48,18.48,0,0,1-1.4,1.4",
    transform: "translate(-327.72 -359.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.1,424.9c-.1,0-.2-.1-.3-.1-16.3-3.6-23.4-10.1-26.1-13.6l.7,25.6a60.87,60.87,0,0,0,18.2,6,62.28,62.28,0,0,0,17.8.3,60.7,60.7,0,0,0,19.9-6.1l4.1-10.3c-5.9.9-18.1,1.8-34.3-1.8",
    transform: "translate(-327.72 -359.17)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.3,407.7l4.7-3.1c3.4-2.2,3.9-4.5,4.2-7.8l.7-7.9c.7-7.9-4-12.2-11.8-12.2H455.3l-.8,9h33.8c3.2,0,4.1,1.2,3.9,4.2l-.5,5.8c-.2,1.7-.4,2.6-2.1,3.7-1.5.9-2,1.3-2.8,1.3H453.3l-2.2,25.6h9.6l1.4-16.6h19.7l10.9,16.6h11.9Z",
    transform: "translate(-327.72 -359.17)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.7,410.9c-1,11-5.7,15.8-16.8,15.8H523.7c-11.1,0-14.9-4.8-14-15.8l1.7-19.1c1-11,5.6-15.7,16.7-15.7h21.2c11.1,0,15,4.7,14,15.7Zm-7.9-19.1c.5-5.5-.6-6.7-6-6.7H528.4c-5.4,0-6.7,1.2-7.1,6.7l-1.7,19.1c-.5,5.5.6,6.8,6,6.8H545c5.4,0,6.7-1.3,7.2-6.8Z",
    transform: "translate(-327.72 -359.17)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "260.07 26.43 239.47 26.43 240.28 17.43 291.18 17.43 290.38 26.43 269.77 26.43 266.18 67.03 256.57 67.03 260.07 26.43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.6,410.9c-1,11-5.7,15.8-16.8,15.8H633.6c-11.1,0-14.9-4.8-14-15.8l1.7-19.1c1-11,5.6-15.7,16.7-15.7h21.2c11.1,0,15,4.7,14,15.7Zm-8-19.1c.5-5.5-.6-6.7-6-6.7H638.2c-5.4,0-6.7,1.2-7.1,6.7l-1.7,19.1c-.5,5.5.6,6.8,6,6.8h19.4c5.4,0,6.7-1.3,7.2-6.8Z",
    transform: "translate(-327.72 -359.17)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "369.98 26.43 349.27 26.43 350.07 17.43 401.07 17.43 400.27 26.43 379.57 26.43 376.07 67.03 366.38 67.03 369.98 26.43"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "413.38 67.03 403.68 67.03 408.07 17.43 417.68 17.43 413.38 67.03"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "483.07 26.43 462.38 26.43 463.18 17.43 514.17 17.43 513.38 26.43 492.68 26.43 489.18 67.03 479.48 67.03 483.07 26.43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M768.4,417.3c-.8,0-1.2-.4-2.2-1.5a3.23,3.23,0,0,1-1.1-2.4l3.2-36.8h-9.6l-3.2,37c-.3,3.2,0,4.9,1.6,6.6l3.2,3.5c1.6,1.7,3.4,2.6,6.6,2.6h31l.8-8.9H768.4Z",
    transform: "translate(-327.72 -359.17)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M835.7,412a7.1,7.1,0,1,0,7.1,7.1,7.13,7.13,0,0,0-7.1-7.1m0,12.8a5.7,5.7,0,1,1,5.7-5.7,5.7,5.7,0,0,1-5.7,5.7",
    transform: "translate(-327.72 -359.17)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.3,419.4a1.11,1.11,0,0,0,.5-1v-1.2a1.81,1.81,0,0,0-2-1.9h-4.2v7.4H834v-2.5h2.1l1.9,2.5h1.6l-2-2.7Zm-.9-1.4a.6.6,0,0,1-.3.6c-.3.2-.4.3-.5.3h-2.7v-2.4h2.7c.6,0,.8.2.8.8Z",
    transform: "translate(-327.72 -359.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRototiltLogo);
export default __webpack_public_path__ + "static/media/Rototilt_logo.909b1b36851aedfb4f75b35fa6fc3d5b.svg";
export { ForwardRef as ReactComponent };